<template>
  <b-container class="font_Montserrat">
    <b-row>
      <b-col sm="12" md="10" offset-md="1" class="mt-5">
        <div class="v2_bg_white v2_box_teal w-100 h-100 p-5 card">
          <v-wait :visible="loading">
            <template slot="waiting">
              <half-circle-spinner />
              <div class="spinner-message my-3 text-center">
                Loading ...
              </div>
            </template>
            <p class="text-center">
              <template v-if="validated">
                <b-alert variant="success" show class="my-2">
                  Email successfully confirmed! Now you can sign in with your
                  credentials!
                </b-alert>
                <router-link to="/login">Go to sign in</router-link>
              </template>
              <template v-else-if="expired">
                <b-alert variant="danger" show class="my-2">
                  Confirmation link was expired!
                </b-alert>
                <b-button
                  variant="v2_primary"
                  @click="repeatLoading"
                  :disabled="repeatLoading"
                >
                  <b-spinner small v-if="repeatLoading" />
                  <span v-else>Send new link</span>
                </b-button>
              </template>
            </p>
          </v-wait>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';
import { SIGN_OUT_ACTION } from '@/store';
export default {
  name: 'RecruiterVerifyEmailToken',
  components: {
    HalfCircleSpinner,
  },
  data: function () {
    return {
      expired: false,
      loading: false,
      repeatLoading: false,
      validated: false,
    };
  },
  created: async function () {
    const { token } = this.$route.params;
    if (!token) {
      this.error = 'Link is broken, try to resend activation email';
    } else {
      if (this.$store.getters.isAuthenticated) {
        await this.$store.dispatch(SIGN_OUT_ACTION);
      }
      await this.checkToken(token);
    }
  },
  methods: {
    checkToken: async function (token) {
      this.loading = true;
      try {
        const { success, expired } = await Api.verifySignUpToken(token);
        if (success) {
          this.validated = true;
          this.expired = false;
        } else if (expired) {
          this.expired = true;
          this.validated = false;
        }
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loading = false;
      }
    },
    repeatVerificationEmail: async function () {
      this.repeatLoading = true;
      try {
        await Api.recruiterRepeatVerificationEmail();
        this.$toasted.success('Email was sent, please check your email', {
          duration: 3000,
        });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.repeatLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  min-height: 350px;
}
</style>
